<template>
   <b-col cols="6" xl="4" lg="4">
    <div>
       <router-link :to="{name: 'gallery', query:{area:name}}">
      <b-card overlay :img-src="areaImage" img-alt="Card Image" text-variant="white" class="my-3">
        <div class="container area-card-overlay">
          <div class="row h-100">
            <div class="col-sm-12 my-auto">
              <div class="area-card-text" :style="{backgroundColor:$store.state.globalTheme.DEFAULT_COLOR}">{{name.toUpperCase()}}</div>
            </div>
          </div>
        </div>
      </b-card>
    </router-link>
    </div>
  </b-col>
</template>

<script>
    export default {
        name: "Area.vue",
        props:['name','id','image'],
        computed: {
            areaImage:function () {
                if(!this.image){
                    return "https://i.vimeocdn.com/video/763951763_640x360.jpg?r=pad"}
                else {
                    return this.image
                    }
                }
            }

    }
</script>

<style scoped>
  .card-img-overlay {
  padding: 0;
}
.area-card-overlay {
  height: 100%;
  padding: 0;
}
.area-card-text {
  padding: 8px;
  font-size: 1em;
}
@media (min-width: 321px) and (max-width: 576px) {
  .area-card-text {
    font-size: 0.8rem;
    padding: 5px;
  }
}
@media (max-width: 320px) {
  .card {
    border: 0;
  }
  .area-card-text {
    background-color: transparent;
    color: #212529;
    font-size: 0.6rem;
  }
  .area-card-overlay {}
  .card-img-overlay {
    position: static;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Area.vue